import {inject, bindable, customElement, DOM} from 'aurelia-framework';
import {I18N} from 'aurelia-i18n';

@inject(I18N, DOM.Element)
@customElement('processing-dialog')
export class ProcessingDialog {
  @bindable() processingTitle = '';
}
